<template>
  <div>
    <CForm @submit.prevent="submit">
      <CModal centered :close-on-backdrop="false" :show.sync="properties.visible">
        <template #header>
          <h5 class="modal-title">
            <i class="fa fa-user-o fa-fw" aria-hidden="true"></i>
            사용자
          </h5>
          <CButtonClose @click="properties.visible = false"></CButtonClose>
        </template>

        <ValidationObserver ref="observer">
          <ValidationProvider v-slot="{ errors }" name="username" rules="required|min:1|max:100">
            <CInput
              label="아이디"
              placeholder="아이디를 입력하세요"
              horizontal
              readonly
              v-model="form.username"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" name="email" rules="required|email|min:4|max:100">
            <CInput
              label="이메일"
              placeholder="이메일을 입력하세요"
              horizontal
              autocomplete="email"
              v-model="form.email"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            />
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" name="name" rules="required|min:1|max:100">
            <CInput
              label="이름"
              placeholder="이름을 입력하세요"
              horizontal
              v-model="form.name"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" name="phone" rules="required|phone|min:12|max:13">
            <CInput
              label="휴대전화"
              placeholder="휴대전화를 입력하세요"
              horizontal
              type="tel"
              autocomplete="phone"
              v-model="form.phone"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>
        </ValidationObserver>

        <template #footer>
          <CButton @click="showChangePasswordModal" class="mr-auto text-light" color="warning">
            비밀번호 변경
          </CButton>
          <CButton @click="properties.visible = false" color="secondary"> 취소</CButton>
          <CButton type="submit" color="success"> 저장</CButton>
        </template>
      </CModal>
    </CForm>
  </div>
</template>

<script>
import { extend, localize, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, max, min, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import core from "@/core";
import MixinsModalBackButton from "@/mixins/modal-back-button";
import UserService from "@/services/user/user.service";

extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    //console.log('value : ', value, ', target : ', target);
    return value === target;
  },
  message: "비밀번호 확인이 일치하지 않습니다",
});
extend("phone", {
  validate(value) {
    return core.utils.validate.phone(value);
  },
  message: "휴대전화 형식이 올바르지 않습니다",
});

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    username: "아이디",
    password: "비밀번호",
    confirmPassword: "비밀번호 확인",
    email: "이메일",
    name: "이름",
    phone: "휴대전화",
  },
});

export default {
  name: "UserProfileModal",
  mixins: [MixinsModalBackButton()],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          visible: false,
          params: {},
          watchClose: {
            result: "",
            item: null,
          },
        };
      },
    },
  },
  data() {
    return {
      form: {
        username: "",
        email: "",
        name: "",
        phone: "",
        currentPassword: "",
        newPassword: "",
        newConfirmPassword: "",
      },
    };
  },
  mounted() {
    this.$nextTick(async () => {
      core.loader.hide();
      const user = await this.$store.dispatch("auth/getUser");
      const form = this.form;
      for (const key of Object.keys(form)) {
        form[key] = user[key];
      }
      const vm = this;
      setTimeout(() => {
        vm.changeValue(false);
      }, 200);
      console.log("user : ", user);
    });
  },
  watch: {
    "form.email"(val) {
      if (val != null) {
        this.changeValue(true);
      }
    },
    "form.name"(val) {
      if (val != null) {
        this.changeValue(true);
      }
    },
    "form.phone"(val) {
      this.form.phone = core.utils.format.hyphenPhone(this.form.phone);
      if (val != null) {
        this.changeValue(true);
      }
    },
  },
  methods: {
    changeValue(changed) {
      const $this = this;
      if (changed != null) {
        $this.backButton.changed = changed;
      } else {
        $this.backButton.changed = true;
      }
    },
    showChangePasswordModal() {
      const modal = this.$store.state.app.modal.changePassword;
      modal.visible = true;

      this.properties.visible = false;
    },
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        try {
          const result = await UserService.update(this.form);
          console.log("result : ", result);
          await this.$store.dispatch("auth/getUser", true);
          await core.alert.show({
            title: "알림",
            body: "회원정보가 수정되었습니다.",
          });
          this.properties.watchClose = {
            result: "confirm",
          };
          this.properties.visible = false;
        } catch (e) {
          console.log("error : ", e);
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
        core.loader.hide();
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
